import * as React from 'react';

import { colors } from '../../theme/colors';

export type BotTrapProps = {
  // the background color of the parent element so the dot is hidden
  backgroundColor?: string;
};

export const BotTrap: React.FC<BotTrapProps> = ({ backgroundColor }) => (
  <a href="/b4db0tty" style={{ pointerEvents: 'none', cursor: 'default', color: backgroundColor || colors.white }}>
    .
  </a>
);
